import React from 'react';
import { Checkbox, FormControlLabel } from '../../../../third-party-components/material-ui';

const CheckedIcon = () => (
    <span className="k-icon k-i-radiobutton-checked" style={{fontSize:'2em'}} />
)

const UnCheckedIcon = () => (
    <span className="k-icon k-i-radiobutton" style={{fontSize:'2em'}}></span>
)


class TaskRadioButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        const { onClick }  = this.props;

        onClick(e);
    }

    render() {
        const {children, option, isSelected} = this.props;

        return (
            <div className="task-radio-button">
                <FormControlLabel
                checked={isSelected} 
                onChange={this.handleClick}
                    control={
                        <Checkbox 
                            icon={<UnCheckedIcon />}
                            checkedIcon={<CheckedIcon />}
                            value={option.value}
                        />
                    }
                    label={children}
                />
            </div>
        )
    }
}

export default TaskRadioButton;